import {
    GET_INTERNSHIP_SERVICES_FAIL,
    GET_INTERNSHIP_SERVICES_SUCCESS,
    ADD_INTERNSHIP_SERVICE_SUCCESS,
    ADD_INTERNSHIP_SERVICE_FAIL,
    UPDATE_INTERNSHIP_SERVICE_SUCCESS,
    UPDATE_INTERNSHIP_SERVICE_FAIL,
    DELETE_INTERNSHIP_SERVICE_SUCCESS,
    DELETE_INTERNSHIP_SERVICE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    internshipServices: [],
    error: null,
    loading: true
};

const internshipServiceReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des interships
        case GET_INTERNSHIP_SERVICES_SUCCESS:
            return {
                ...state,
                internshipServices: action.payload, // tableau d'objets intership
                loading: false,
                error: null
            };

        case GET_INTERNSHIP_SERVICES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une intershipe
        case ADD_INTERNSHIP_SERVICE_SUCCESS:
            return {
                ...state,
                internshipServices: [action.payload, ...state.internshipServices], // ajoute au début du tableau
                error: null
            };

        case ADD_INTERNSHIP_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une intershipe
        case UPDATE_INTERNSHIP_SERVICE_SUCCESS:
            return {
                ...state,
                internshipServices: state.internshipServices.map(internshipService =>
                    internshipService.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet intership
                        : internshipService
                ),
                error: null
            };

        case UPDATE_INTERNSHIP_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une intershipe
        case DELETE_INTERNSHIP_SERVICE_SUCCESS:
            return {
                ...state,
                internshipServices: state.internshipServices.filter(
                    internshipService => internshipService.id !== action.payload
                ),
                error: null
            };


        case DELETE_INTERNSHIP_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default internshipServiceReducer;
